// src/components/Modal.tsx

import React from 'react';

type ModalProps = {
  message: string;
  isOpen: boolean;
  onClose: () => void;
};

const NotificationModal: React.FC<ModalProps> = ({ message, isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40'>
      <div className='bg-white p-6 rounded-2xl shadow-lg w-[90%] max-w-md text-center animate-fade-in'>
        <h2 className='text-xl font-semibold mb-4'>📢 New notification</h2>
        <p className='text-gray-700 mb-6'>{message}</p>
        <button
          onClick={onClose}
          className='px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition'
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default NotificationModal;
